module.exports = __webpack_public_path__ + "static/img/banner_6.23b842c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_6.jpg
// module id = +1fw
// module chunks = 1